export default function isIosBrowser(): boolean {
  const { userAgent = '', maxTouchPoints = 0 } = window.navigator

  return /iPhone|iPad|iPod/i.test(userAgent) || (/Macintosh/i.test(userAgent) && maxTouchPoints > 1)
}
